export class MissingDataError extends Error {
    keywords: string[]

    constructor(message: string, keywords: string[] = []) {
        super(message)
        this.name = "MissingDataError"
        this.keywords = keywords
    }
}

export function isMissingDataError(error: unknown): error is MissingDataError {
    return (
        error instanceof MissingDataError ||
        (typeof error === "object" && error !== null && (error as { name?: string }).name === "MissingDataError")
    )
}
